// extracted by mini-css-extract-plugin
module.exports = {"hero":"k2u4YkrM1ERSVQ3HhoQ2l","paragraph":"_2niYEdZ427d9YybD4xBxEt","styleButton":"_2heWbIKX0QJbTB0ACMXbxF"};